import md5 from 'md5';

export const validatePassword = str => {
	if (!str) return false;
	const rgExp = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
	return rgExp.test(str);
};

export const validateWhiteSpaces = str => {
	if (!str) return false;
	return str.trim().length >= 1 ? true : false;
};

export const getProfilePhoto = email => {
	return `https://www.gravatar.com/avatar/${md5(email)}`;
};
